import React, { Component } from 'react';
import { Icon, Label, List, Popup, Checkbox, Divider } from 'semantic-ui-react';
import { source } from 'react-aim';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import EllipsisTooltip from './../../common/EllipsisTooltip'
import CreateNewWorkspaceModal from './../../account/dashboard/drive/Modal/CreateNewWorkspaceModal'
import convertCamelCase from '../../../helpers/convert-camel-case'

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext("Workspace Selection")
    }
})
class OrgSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            createNewWorkspaceModalFlag: false,
            type: null
        }
        this.openCreateNewWorkspaceModal = this.openCreateNewWorkspaceModal.bind(this)
    }

    markDefault(e, d, data) {
        let payload = {
            accountId: this.props.selectedAccount._id,
            organizationId: data.id,
            default: d.checked
        }
        dispatch.organizationUnit.setDefaultWorkspace(payload);
    }

    async organisationSelected(e, d, payload) {
        this.setState({ isOpen: false })
        e.persist();
        let orgSelected = this.props.organizations.filter((org) => { return org.id === payload.id })[0];

        await this.props.setOrganization(orgSelected);
        const { history } = this.props;
        if (payload.role === "Member") {
            history.push('/app/' + this.props.selectedAccount._id + '/_ws/' + payload.id + '/_at/myactivities');
        } else {
            history.push('/app/' + this.props.selectedAccount._id + '/_ws/' + payload.id + '/_pb');
        }
        await dispatch.invite.clear();
        await dispatch.register.clear();
        await dispatch.profile.clear();
        await dispatch.forgot.clear();
        await dispatch.reset.clear();
        await dispatch.organizationUnit.clear();
        await dispatch.organizationTab.clear();
        await dispatch.community.clear();
        await dispatch.users.clear();
        await dispatch.lifeCycle.clear();
        await dispatch.workspaceMetaData.setWspaceMetadata({}) // Added for workspace metadata KLM-8948
        if (this.props.selectedOrganisation.id !== payload.id) {
            await dispatch.initiatives.clear();
        }
        await dispatch.content.clear();
        await dispatch.createPack.clear();
        // await dispatch.notifications.clear();
        dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": this.props.selectedAccount._id });
        dispatch.lifeCycle.getCounts({ id: payload.id });
        await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"]);
        await dispatch.lifeCycle.getPacksByStatusArray({ 
            organizationId: payload.id,
            status: ["-1","0","1","2","3","4","5","10"],
            accountUserId: this.props.user._id,
            role: payload.role
        });
        dispatch.notifications.getEventStreamByOrganization({});
        // dispatch.notifications.getEventStreamForCommunity({});

    }

    addWorkspace = () => {
        this.setState({ isOpen: false })
        dispatch.app.addOrgModalOpen(true);
    }

    closeWorkspaceModal = () => {
        dispatch.app.addOrgModalOpen(false);
    }

    onSubmit = (formData) => {
        dispatch.app.addNewWorkspace({
            workspaceName: formData.name.trim(),
            user: this.props.user,
            accountId: this.props.selectedAccount._id,
            redirectTo: "workspace"
        });
    }

    handleOpen = () => {
        this.setState({ isOpen: true })
    }

    handleClose = () => {
        this.setState({ isOpen: false })

    }
    goToAccount = () => {
        const { history } = this.props;
        history.push('/app/' + this.props.selectedAccount._id + '/dashboard');
    }

    openCreateNewWorkspaceModal(open, type) {
        this.setState({ isOpen: false })
        this.setState({
            createNewWorkspaceModalFlag: open,
            type: type
        })
    }


    render() {

        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });

        let userOrganizations = this.props.organizations &&
            this.props.organizations.sort((a, b) => {
                return collator.compare(a.name, b.name)
            })
        
        let uniqueWorkspaceIds = {};
        let filteredOrganizations = userOrganizations.filter((organization) => {
            if (!uniqueWorkspaceIds[organization.id]) {           
                uniqueWorkspaceIds[organization.id] = true;
                return true;
                } else {
                 return false;
                }
            });
        let activeOrganizations = filteredOrganizations.filter((a) => a.active === true)
        const selectedOrganisation = this.props.selectedOrganisation;
        const orgCreationError = this.props.orgCreationError;

        let isCreateWorkspaceDisabled = false;
        let userRoleInAccount = this.props.user && this.props.selectedAccount && this.props.user.accounts.filter((account, i) => { return account.id === this.props.selectedAccount._id })[0].role;
        if (userRoleInAccount === "user" && this.props.selectedAccount.subscriptionType !== "Workgroup") {
            isCreateWorkspaceDisabled = true; // for now user is aloowed to create wokspace
        }


        return (
            selectedOrganisation ?
                <React.Fragment>
                    <Popup
                        trigger={
                            <div className="org-selector acc-box dropdown-box dd-hover w_200 pad_8 cursor-pointer">
                                <div className="acc-image" style={{ marginTop: "5px"}}>
                                    <Icon name="world" />
                                </div>
                                <div className="acc-text " style={{ width: "148px" }}  >
                                    <div className="acc-name" >
                                        <EllipsisTooltip
                                            name={selectedOrganisation.name}
                                            position="left bottom"
                                            style={{ lineHeight: "16px" }}
                                        />
                                    </div>
                                    <div className="acc-role" >
                                        {convertCamelCase(selectedOrganisation.role)}
                                        {
                                            selectedOrganisation.default ?
                                                <span className="float-right" style={{ margin: "0 0 0 0" }}>
                                                    <Label color='blue' size="mini" style={{ borderRadius: "2em" }} > Default </Label>
                                                </span> : null
                                        }
                                    </div>
                                </div >
                            </div >
                        }
                        on='click'
                        open={this.state.isOpen}
                        onClose={this.handleClose}
                        onOpen={this.handleOpen}
                        style={{ padding: "10px 0 0 0" }}
                        position="bottom left"
                    >
                        <Popup.Content style={{ width: "300px" }}>
                            <List divided verticalAlign='middle' className="w_100 f_12 display-block">
                                <List.Item style={{ margin: "0px 8px 5px 8px" }}>
                                    <List.Content floated='right'>
                                        Default
                                        </List.Content>
                                    <List.Content className="ff_sb" style={{ padding: "0px 5px", margin: " 0 0 0 0" }}>
                                        Workspaces &nbsp;
                                    <Label circular size="mini" color="blue">
                                            {activeOrganizations && activeOrganizations.length}
                                        </Label>
                                    </List.Content>
                                </List.Item>
                            </List>
                            <Divider style={{ margin: 0 }} />
                            <List divided verticalAlign='middle' className="w_100 f_12 display-block" style={{ overflow: "auto", maxHeight: "200px", margin: "0px 0" }}>
                                {activeOrganizations && activeOrganizations.map((org, i) => {
                                    return (
                                        <List.Item key={i} style={{ padding: "3px 8px" }} className='hover-item'>
                                             {org.name === selectedOrganisation.name ?
                                                <Label circular color="green" empty style={{ margin: "6px 0 0 9px", float: "left" }} />
                                                : null}
                                            <List.Content floated='right'>
                                                <Checkbox toggle
                                                    checked={org.default}
                                                    disabled={org.default}
                                                    onChange={(e, d) => { this.markDefault(e, d, org) }}
                                                />
                                            </List.Content>
                                            <List.Content style={{ padding: "1px 13px", margin: " 0 0 0 12px" }}>
                                                <div onClick={(e, d) => { this.organisationSelected(e, d, org) }}>
                                                    <EllipsisTooltip
                                                        name={org.name}
                                                        style={{ padding: "2px 0 0 10px", cursor: "pointer", lineHeight: "16px" }}
                                                        className="list-effect"
                                                    />
                                                </div>
                                            </List.Content>
                                        </List.Item>
                                    )
                                })}
                            </List>
                            {!isCreateWorkspaceDisabled ?
                                <React.Fragment >
                                    <Divider style={{ margin: 0 }} />
                                    <List divided verticalAlign='middle' className="w_100 f_12 display-block mar_0">
                                        <List.Item className="popup-view" onClick={() => this.openCreateNewWorkspaceModal(true, "create")}
                                        >
                                            <List.Content className="clr-blue">Create New Workspace</List.Content>
                                        </List.Item>
                                    </List>
                                </React.Fragment>
                                : null}
                        </Popup.Content>
                    </Popup>
                    <CreateNewWorkspaceModal
                        open={this.state.createNewWorkspaceModalFlag}
                        type={this.state.type}
                        accountId={this.props.selectedAccount._id}
                        user={this.props.user}
                        orgCreationError={orgCreationError}
                        openCreateNewWorkspaceModal={this.openCreateNewWorkspaceModal}
                        accountSubscriptionDetail={this.props.accountSubscriptionDetail}
                    />
                </React.Fragment> : <div></div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isAddOrgModalOpen: state.app.isAddOrgModalOpen,
        user: state.app.user,
        selectedOrganisation: state.app.selectedOrganisation,
        orgCreationError: state.app.orgCreationError,
        accountSubscriptionDetail: state.app.accountSubscriptionDetail
    };
}

const connectedOrgSelector = connect(mapStateToProps)(OrgSelector);
export { connectedOrgSelector as OrgSelector };